import Constants from '@intercom/embercom-composer/lib/constants';
import Em from 'ember';
const PROTOCOL_BLOCKLIST = ['javascript', 'vbscript', 'frames', 'data', 'ftp', 'sftp'];
function matchesProtocolOnBlocklist(url) {
  return !!PROTOCOL_BLOCKLIST.find(protocol => {
    let protocolRegex = new RegExp(`^${protocol}:`);
    if (protocolRegex.test(url)) {
      return true;
    }
  });
}
export default Em.Mixin.create({
  cleanUrl(property) {
    let url = this.get(property);
    if (url) {
      url = url.replace(new RegExp(Constants.ZERO_WIDTH_SPACE, 'g'), '');
      url = url.trim();
      let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i;
      let isEmail = emailRegex.test(url);
      let hasMailTo = /^mailto:/.test(url);
      let hasProtocol = url.indexOf(':') !== -1;
      let isRelative = url.indexOf('/') === 0;
      let isAttribute = url.indexOf('{{') === 0;
      if (url && !isAttribute && !hasProtocol && !hasMailTo && !isEmail && !isRelative) {
        url = `http://${url}`;
      }
      if (isEmail && !hasMailTo) {
        url = `mailto:${url}`;
      }
      if (matchesProtocolOnBlocklist(url)) {
        url = '';
      }
      this.set(property, url);
    }
  }
});